<div class="maintenance">
    <header class="maintenance__header">
        <div class="maintenance__header__content">
            <div class="maintenance__lang">
                <i class="bi bi-globe"></i>
                <button
                    class="maintenance__lang__trigger"
                    (click)="toggleLang($event)"
                >
                    {{ currentLangtxt }}
                </button>
                <img
                    class="maintenance__lang__arrow"
                    alt="arrow menu"
                    [src]="'images/arrow_select.svg' | cdn"
                />
                <ul class="maintenance__lang__menu" [class.open]="isLangOpen">
                    <li>
                        <a
                            [attr.href]="
                                [
                                    env.baseUrl,
                                    currentLanguage === 'en' ? 'es' : 'en'
                                ].join('/')
                            "
                        >
                            {{ idiomaChange }}
                        </a>
                    </li>
                </ul>
            </div>

            <img
                class="maintenance__logo"
                alt="logo alamo"
                [src]="'images/logo-alamo.webp' | cdn"
            />

            <a
                class="maintenance__contact"
                href="tel:{{ 'fe_header_menu_link_phone' | translate }}"
            >
                <img alt="whatsapp" [src]="'images/icon-whatsapp.svg' | cdn" />
                {{ 'fe_header_menu_link_phone' | translate }}
            </a>
        </div>
    </header>

    <main class="maintenance__body">
        <div class="maintenance__container">
            <div class="maintenance__status">
                <img
                    class="maintenance__status__icon"
                    alt="mantenimiento"
                    [src]="'images/blue-phone.png' | cdn"
                />
                <div class="maintenance__status__text">
                    <h1>{{ 'fe_maintenance_status_h2_title' | translate }}</h1>
                    <p>{{ 'fe_maintenance_status_h3_subtitle' | translate }}</p>
                </div>
            </div>

            <div class="maintenance__cards">
                <article class="maintenance__card">
                    <div class="maintenance__card__head">
                        <img
                            class="maintenance__card__icon maintenance__card__icon--phone"
                            alt="telefono"
                            [src]="'images/phone-mantaince.png' | cdn"
                        />
                        <div class="maintenance__card__intro">
                            <h2>
                                {{
                                    'fe_maintenance_contact-phone_h3_title'
                                        | translate
                                }}
                            </h2>
                            <p>
                                {{
                                    'fe_maintenance_contact-phone_p_subtitle'
                                        | translate
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="maintenance__card__detail">
                        <p class="maintenance__card__label">
                            <span>{{
                                'fe_maintenance_contact-phone_p_customer-service'
                                    | translate
                            }}</span>
                            <span>{{
                                'fe_maintenance_contact-phone_p_rentals-mexico'
                                    | translate
                            }}</span>
                        </p>
                        <a
                            class="maintenance__card__link"
                            href="tel:{{
                                'fe_core_link_contact-phone' | translate
                            }}"
                        >
                            {{
                                'fe_core_format_link_contact-phone' | translate
                            }}
                        </a>
                    </div>
                </article>

                <article class="maintenance__card">
                    <div class="maintenance__card__head">
                        <img
                            class="maintenance__card__icon maintenance__card__icon--email"
                            alt="correo"
                            [src]="'images/mail.png' | cdn"
                        />
                        <div class="maintenance__card__intro">
                            <h2>
                                {{
                                    'fe_maintenance_contact-email_h3_title'
                                        | translate
                                }}
                            </h2>
                            <p>
                                {{
                                    'fe_maintenance_contact-email_p_subtitle'
                                        | translate
                                }}
                            </p>
                        </div>
                    </div>
                    <div
                        class="maintenance__card__detail maintenance__card__detail--email"
                    >
                        <a
                            class="maintenance__card__link maintenance__card__link--email"
                            href="mailto:{{
                                'fe_maintenance_contact-email_a_mail'
                                    | translate
                            }}"
                        >
                            {{
                                'fe_maintenance_contact-email_a_mail'
                                    | translate
                            }}
                        </a>
                    </div>
                </article>
            </div>
        </div>
    </main>
</div>
